import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AuthenticatedApp from "./components/AuthenticatedApp.jsx";
import { AnimatePresence, LayoutGroup } from "framer-motion";
import { bootstrapMsal, msalInstance } from "./auth.js";
import { ToastContainer } from "react-toastify";



const App = () => {
  const { accounts, instance } = useMsal();
  const location = useLocation();

  // Just grab the first account (MSAL supports multi-account but you likely only need one)
  const user = accounts[0] || null;

  console.log("Current path:", window.location.pathname, window.location.search);
  console.log("Current user:", user?.username);

  useEffect(() => {
    (async () => {
      const acct = await bootstrapMsal();
      if (!acct) {
        msalInstance.loginRedirect({ scopes: ["User.Read"] });
      }
    })();
  }, []);


  return (
    <>
      <LayoutGroup>
        <AnimatePresence>
          <Routes location={location} key={location.pathname}>
            <Route path="/*" element={
              <AuthenticatedApp
                user={user}
                useremail={user?.username}
                onLogin={() => instance.loginPopup()}
                onLogout={() => instance.logoutPopup()}
                location={location}
              />

            } />
          </Routes>
        </AnimatePresence>
      </LayoutGroup>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
